import React from 'react';
import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { ImageDescription } from 'components/structures/general';
import { contentMarketingImage, contentMarketingImage2x, contentMarketingImageBg } from 'images/digital-marketing';
import { greenSquareIcon } from 'images/contact-us';

const useStyles = makeStyles((theme: Theme) => ({
  imageWrapper: {
    position: 'relative',
    alignItems: 'center',
    display: 'flex',
  },
  imageClass: {
    [theme.breakpoints.up('md')]: {
      position: 'static',
      borderRadius: theme.spacing(0, 4),
      maxWidth: 'calc(100% - 70px)',
      marginLeft: 'auto',
      display: 'block',
      margin: theme.spacing(0, 'auto'),
    },
  },
  borderImage: {
    [theme.breakpoints.up('md')]: {
      display: 'block',
      position: 'absolute',
      left: 30,
      width: '40%',
      bottom: 45,
      height: '33%',
      borderLeft: `40px solid ${theme.palette.switchedColors.main}`,
      borderTop: `30px solid ${theme.palette.switchedColors.main}`,
      borderRadius: theme.spacing(0, 4),
      backgroundColor: theme.palette.switchedColors.main,
      zIndex: -1,
    },
    [theme.breakpoints.up('lg')]: {
      left: 19,
      width: '50%',
      bottom: -15,
      height: '43%',
    },
  },
  miniSquare: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
      maxWidth: 95,
      width: '100%',
      position: 'absolute',
      right: 5,
      top: 35,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 120,
      top: -35,
    },
  },
}));

const ContentMarketingBlock = () => {
  const classes = useStyles();
  return (
    <ImageDescription
      image={{
        image: contentMarketingImage,
        srcSet: `${contentMarketingImage} 543w, ${contentMarketingImage2x} 1085w`,
        imageClass: classes.imageClass,
        imageWrapperClass: classes.imageWrapper,
        imageElements: (
          <>
            <div className={classes.borderImage} />
            <img className={classes.miniSquare} src={greenSquareIcon} alt="square bg" />
          </>
        ),
        imageCenterLg: true,
      }}
      bgImage={{ image: contentMarketingImageBg }}
      upperTitle="Concise content strategy"
      title="Content marketing"
      text={
        'US Software Solutions has ample experience creating informative, helpful content to increase brand awareness and traffic, attracting more customers. One of the most critical parts of content marketing is to show users the primary "value" of a service or product. Whether the content is provided for free or via a subscription, the user should receive information that will motivate him to become your company\'s client.'
      }
      gridItems={{ imageLg: 6, imageMd: 6, contentLg: 6, contentMd: 6 }}
    />
  );
};

export default ContentMarketingBlock;
